import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { auth } from '../services/api';
import toast from 'react-hot-toast';
import { Mail } from 'lucide-react';

export default function ResetPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await auth.requestReset(email);
      setSent(true);
    } catch {
      toast.error('Error al enviar la solicitud.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card animate-in">
        <h2>Recuperar contraseña</h2>
        {sent ? (
          <div style={{ textAlign: 'center' }}>
            <Mail size={48} color="var(--blue-400)" style={{ margin: '16px 0' }} />
            <p style={{ color: 'var(--gray-600)', marginBottom: 20 }}>
              Si el correo está registrado, recibirás las instrucciones para restablecer tu contraseña.
            </p>
            <Link to="/login" className="btn btn--secondary">
              Volver a iniciar sesión
            </Link>
          </div>
        ) : (
          <>
            <p>Introduce tu correo electrónico registrado</p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Correo electrónico</label>
                <input
                  className="form-input"
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="btn btn--primary btn--lg" disabled={loading} style={{ width: '100%' }}>
                {loading ? 'Enviando...' : 'Enviar instrucciones'}
              </button>
            </form>
            <div style={{ textAlign: 'center', marginTop: 16, fontSize: '0.85rem' }}>
              <Link to="/login">Volver a iniciar sesión</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
